// The goals a member picks at onboarding, in one place. The onboarding screen
// (src/web/app.ts), the supplement map importer and the suggestion matcher all
// read this list, so a goal in the map is always a goal a member can have.

export const MEMBER_GOALS = Object.freeze([
  'More energy', 'Easier digestion', 'Deeper sleep', 'Less stress', 'Nourishing meals', 'Moving more',
]);

/** How many goals a member may hold. The setup screen, Profile and the server all read this. */
export const GOAL_MAX = 3;

/**
 * Loose words a scan focus area may use for a goal. A scan area that matches one of
 * these only moves that goal's suggestions earlier in the list; it never adds or
 * removes a suggestion. Whole words, case insensitive.
 */
export const GOAL_AREA_ALIASES = Object.freeze({
  'More energy': ['energy', 'vitality', 'stamina'],
  'Easier digestion': ['digestion', 'digestive', 'gut', 'bloating'],
  'Deeper sleep': ['sleep', 'rest', 'rhythm'],
  'Less stress': ['stress', 'calm', 'mood', 'nervous system'],
  'Nourishing meals': ['nutrition', 'nutrients', 'meals', 'hydration'],
  'Moving more': ['movement', 'activity', 'strength', 'mobility'],
});
